export default __webpack_public_path__ + "static/media/pointingguy.87448157.png";